import OperationNatureModel from './operation-nature-model';
import ExchangeBankModel from './exchange-bank-model';
import ExchangeBankTypeModel from './exchange-bank-type-model';
import CustomerLimitModel from './customer-limit-model';
import Workflow from '../../../common/models/Workflow';
import { CUSTOMER_EXCHANGE_BANK_WORKFLOW } from "../../../common/workflows/customerExchangeBankWorkflow";

export default class CustomerExchangeBankModel {
  constructor(obj) {
    obj = obj || {};

    const operationNatures = obj.operationNatures?.map(o => new OperationNatureModel(o));

    this.id = obj.id;
    this.bank = new ExchangeBankModel(obj.bank);
    this.exchangeType = new ExchangeBankTypeModel(obj.exchangeType);
    this.operationNatures = operationNatures?.length ? operationNatures : [];
    this.limit = new CustomerLimitModel(obj.limit);
    
    // Para bancos stablecoin (isDigitalCurrency), o status inicial deve ser "CADASTRO_EM_ANDAMENTO"
    // para permitir ajuste de pendências. Para outros bancos, mantém "ENVIADO_AO_BANCO"
    const defaultStatus = this.bank?.isDigitalCurrency 
      ? CUSTOMER_EXCHANGE_BANK_WORKFLOW.CADASTRO_EM_ANDAMENTO 
      : CUSTOMER_EXCHANGE_BANK_WORKFLOW.ENVIADO_AO_BANCO;
    
    
    this.status = obj.status?.id ? new Workflow(obj.status) : new Workflow(defaultStatus);
    this.integration = obj.integration;
    this.limitProgression = obj.limitProgression;
    // Banco DolsPay: provedores escolhidos ao adicionar; null = todos os ativos
    this.stablecoinProviderIds = Array.isArray(obj.stablecoinProviderIds) ? [...obj.stablecoinProviderIds] : null;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
  }
}
